
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M3.281 7c0-.694.191-1.343.523-1.9V2.74h-2.36A6.947 6.947 0 000 7c0 1.56.508 3.043 1.444 4.26h2.36V8.9A3.696 3.696 0 013.281 7z","fill":"#FBBD00"}}),_c('path',{attrs:{"d":"M7 10.719l-1.64 1.64L7 14c1.56 0 3.043-.508 4.26-1.444v-2.358H8.902a3.718 3.718 0 01-1.902.52z","fill":"#0F9D58"}}),_c('path',{attrs:{"d":"M3.803 8.9l-2.36 2.36c.186.24.388.471.606.69A6.954 6.954 0 007 14v-3.28A3.72 3.72 0 013.804 8.9z","fill":"#31AA52"}}),_c('path',{attrs:{"d":"M14 7a7.06 7.06 0 00-.115-1.268l-.061-.336H7v3.28h3.321a3.702 3.702 0 01-1.419 1.522l2.358 2.358c.24-.186.471-.388.69-.606A6.954 6.954 0 0014 7z","fill":"#3C79E6"}}),_c('path',{attrs:{"d":"M9.63 4.37l.29.29 2.32-2.32-.29-.29A6.954 6.954 0 007 0L5.36 1.64 7 3.282c.993 0 1.927.387 2.63 1.09z","fill":"#CF2D48"}}),_c('path',{attrs:{"d":"M7.001 3.281V0c-1.87 0-3.628.728-4.95 2.05-.218.219-.42.45-.606.69l2.36 2.36a3.72 3.72 0 013.196-1.819z","fill":"#EB4132"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h14v14H0z"}})])])])
          )
        }
      }
    